/**
 * Window CustomEvent used to signal that an AI-generated content calendar has been
 * accepted/confirmed in the AI assistant drawer. The content calendar listens for this
 * to auto-select the accepted calendar's suggestions.
 *
 * Mirrors the existing `scheduleSuccess` CustomEvent pattern in
 * `components/campaigns/CampaignCalendar/context.tsx`.
 */
export const CONTENT_CALENDAR_ACCEPTED_EVENT = 'content-calendar-accepted';

export interface ContentCalendarAcceptedEventDetail {
	calendarId: string;
}

export type ContentCalendarAcceptedEvent = CustomEvent<ContentCalendarAcceptedEventDetail>;

/** Dispatch the accept event so a mounted content calendar can auto-select the suggestions. */
export function dispatchContentCalendarAccepted(calendarId: string): void {
	window.dispatchEvent(
		new CustomEvent<ContentCalendarAcceptedEventDetail>(CONTENT_CALENDAR_ACCEPTED_EVENT, {
			detail: { calendarId },
		})
	);
}
